<template>
  <div>
    <vote-details-list v-if="fullTextReview" :reference="reference" />
    <template v-else>
      <vote-log-item
        v-for="vote in reference.reviewerScreeningVotes"
        :key="vote.id"
        :researcher="vote.reviewer && vote.reviewer.researcher"
        :vote="vote.vote"
        :date="vote.createdAt"
      />
      <vote-log-item
        v-if="resolvedByOtherMeans"
        :researcher="reference.screeningOutcome.resolvedBy.researcher"
        :resolution="reference.screeningOutcome.outcome"
        :date="reference.screeningOutcome.updatedAt"
      />
    </template>
  </div>
</template>

<script>
import VoteLogItem from '@/components/References/VoteLogItem';
import VoteDetailsList from '@/components/References/VoteDetailsList';
import { Reference } from '@/models';
import { ScreeningOutcomeResolution } from '@/enums';

export default {
  name: 'VoteLog',
  components: { VoteLogItem, VoteDetailsList },
  props: {
    reference: {
      type: Reference,
      required: true,
    },
    fullTextReview: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    resolvedByOtherMeans() {
      return (
        this.reference.screeningOutcome.resolution !==
        ScreeningOutcomeResolution.UNANIMOUS_VOTE
      );
    },
  },
};
</script>
